import { Grid, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import ClearIcon from '@mui/icons-material/Clear'

export interface IFilterMapped {
  page?: number;
  perPage?: number;
  search?: string;
}

interface FilterGroupProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const CustomerBlackListFilter = ({ filter, onFilterChange, onSearch }: FilterGroupProps) => {
  const { page, perPage, search } = filter

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={6}>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          label={'ชื่อผู้ใช้งาน, เบอร์ติดต่อ'}
          fullWidth
          id="search"
          name="search"
          variant="filled"
          value={search ?? ""}
          onChange={(e) => onFilterChange({ ...filter, search: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <Button
          color="primary"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => {
            onFilterChange({
              page,
              perPage,
              search: undefined,
            })
            onSearch({
              page,
              perPage,
              search: undefined,
            })
          }}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default CustomerBlackListFilter